import { IAnimateEmojiProps } from "interfaces";
import Emoji from "../../../emoji/emoji";

const AnimatedEmoji = ({ emojiCode, direction }: IAnimateEmojiProps) => {
    return (
        <div
            className={`pl-absolute ${
                direction === "RIGHT" ? "pl-right-3" : "pl-left-3"
            } pl-w-max pl-h-max pl-cursor-auto pl-bottom-14 pl-px-2 pl-py-1 ${
                direction === "RIGHT" ? "pl-uni-first-line-emoji-right" : "pl-uni-first-line-emoji-left"
            }`}
        >
            <Emoji name={emojiCode} className="pl-w-[16px] pl-h-[16px] pl-cursor-auto" />
        </div>
    );
};

export default AnimatedEmoji;
